import { DevelopmentalData } from "@/types/developmental";

export const age3Activities: DevelopmentalData = {
  motor: [
    "Tricycle riding",
    "Dancing games",
    "Art projects",
    "Ball games",
    "Playground activities"
  ],
  language: [
    "Storytelling",
    "Word games",
    "Rhyming activities",
    "Show and tell",
    "Conversation practice"
  ],
  cognitive: [
    "Number games",
    "Shape sorting",
    "Memory games",
    "Pattern making",
    "Problem-solving activities"
  ],
  independent: [
    "Dressing games",
    "Cleaning tasks",
    "Personal care routines",
    "Simple food prep",
    "Organization activities"
  ],
  social: [
    "Group games",
    "Role-playing",
    "Sharing activities",
    "Team projects",
    "Emotional expression games"
  ]
};